import { useEffect } from 'react'
import { Outlet, useLocation, useMatches } from 'react-router-dom'

const _window = window as any

/**
 * 子应用布局(布局、导航定位)
 */
export const AppLayout = () => {
  const matches = useMatches()
  const { pathname } = useLocation()

  useEffect(() => {
    if (_window.__MICRO_APP_ENVIRONMENT__) {
      _window.microApp.forceDispatch({ layoutOptions: { showNav: true, showHeader: true } })
    }

    return () => {
      // 组件注销时，布局切换
      if (_window.__MICRO_APP_ENVIRONMENT__) {
        _window.microApp.forceDispatch({ layoutOptions: { showNav: false, showHeader: false } })
      }
    }
  }, [])

  useEffect(() => {
    // 监听路由匹配变化
    if (_window.__MICRO_APP_ENVIRONMENT__) {
      _window.microApp.forceDispatch({ matches: matches })
    }
  }, [pathname])

  return (
    <>
      <Outlet />
    </>
  )
}
